import * as ActionTypes from '~/actions/ActionTypes'

export const endProjectLoading = () => async dispatch => {
  await dispatch({ type: ActionTypes.PROJECTS_END_PROJECT_LOAING })
}
